<template>
    <div class="feedback-container-ths" :class="{'step-end__container' : stepProgress > maxStepsCount }">
        <PageLoader v-if="processing" />
        <FeedbackHeader v-if="stepProgress <= maxStepsCount" :survey-already-completed="surveyAlreadyCompleted" :backLink=true :title="currentQuestionDescription" :pretitle="currentSurveyTitle" v-on:goBack="goBack" :stepProgress="stepProgress" :maxStepsCount="maxStepsCount" />
        <div class="container is-centered feedback">

            <div class="feedback-content has-margin-top-30">

                <div v-show="stepProgress <= maxStepsCount" :class="{'full-height' : currentStepComponent !== 'StepOnlyFeedback'}">
                    <component
                        v-bind:is="currentStepComponent"
                        :feedback-data="currentSurveyQuestions[stepProgress - 1]"
                        :saved-answer="currentAnswer"
                        :survey-passing-id="surveyPassingId"
                        v-on:showFeedback="openAddFeedbackStep"
                        v-on:updateProgress="canProgress = $event"
                        ref="currentComponent"
                    />
                </div>

                <StepAddFeedback
                    v-if="showAddFeedback"
                    :feedback-data="currentSurveyQuestions[stepProgress - 1]"
                    :saved-answer="currentAnswer"
                    :feedback="feedbackText"
                    ref="stepAddFeedback"
                />

                <StepEnd
                    v-if="stepProgress === maxStepsCount + 1"
                    :survey-already-completed="surveyAlreadyCompleted"
                    :saved-answers="savedAnswers"
                />
            </div>

            <div class="feedback-footer has-margin-bottom-25">
                <b-button
                    v-if="stepProgress <= maxStepsCount"
                    class="button-ths--link-blue-dk"
                    :class="{ disabled: !canProgress }"
                    type="is-danger"
                    expanded
                    @click="footerBtnAction(false)"
                    >{{ footerBtnName }}</b-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import StepAddFeedback from "@/components/feedback/StepAddFeedback";
import StepYesNo from "@/components/feedback/StepYesNo";
import StepOrderedTags from "@/components/feedback/StepOrderedTags";
import StepMultiChoice from "@/components/feedback/StepMultiChoice";
import StepScale from "@/components/feedback/StepScale";
import StepEnd from "@/components/feedback/StepEnd";
import StepOnlyFeedback from "@/components/feedback/StepOnlyFeedback";
import PageLoader from "@/components/PageLoader";
import FeedbackHeader from '@/components/FeedbackHeader.vue'

export default {
    name: "FeedbackPage",
    data() {
        return {
            processing: false,
            stepProgress: 1,
            currentStep: "yesno",
            feedbackText: "",
            savedAnswers: [],
            showAddFeedback: false,
            surveyAlreadyCompleted: false,
            timeoutId: null,
            langMessages: this.$i18n.locale,
            questionDescription: "",
            canProgress: false
        };
    },
    components: {
        StepAddFeedback,
        StepYesNo,
        StepScale,
        StepOrderedTags,
        StepMultiChoice,
        StepOnlyFeedback,
        PageLoader,
        StepEnd,
        FeedbackHeader,
    },
    mounted() {
        if (this.isAuthenticated) {
            this.processing = true;
            Promise.all([
                this.$store.dispatch("getCurrentSurvey", { id: this.$store.state.feedback.surveyId }),
                this.$store.dispatch("getCurrentSurveyAnswers", { id: this.$store.state.feedback.surveyId }),
            ]).finally(() => {
                this.processing = false;

                this.defineCurrentStep();
            });
        } else {
            this.$router.push("/sign-in");
        }
    },
    computed: {
        maxStepsCount() {
            return (
                (this.currentSurveyQuestions &&
                    this.currentSurveyQuestions.length) ||
                3
            );
        },
        footerBtnName() {
            return this.stepProgress <= this.maxStepsCount
                ? this.$i18n.messages[this.$store.state.lang.locale].next
                : 'Complete';
        },
        currentSurvey() {
            return this.$store.state.feedback.currentSurvey;
        },
        currentSurveyName() {
            let name = this.currentSurvey?.name

            return name;
        },
        currentSurveyTitle() {
            let title = this.currentSurvey?.title

            return title;
        },
        currentQuestionDescription() {
            let description = this.currentStep?.description

            return description;
        },
        currentAnswer() {
            if (this.savedAnswers) {
                let currentAnswer = this.savedAnswers.find((answ) => {
                    return (
                        answ.question_id ==
                        (this.currentStep && this.currentStep.id)
                    );
                });
                return (currentAnswer && currentAnswer.answer_data) || null;
            }
            return 0;
        },
        currentSurveyQuestions() {
            let currentSurveyQuestions =
                this.currentSurvey && this.currentSurvey.questions;
            return currentSurveyQuestions || [];
        },
        currentSurveyAnswers() {
            return this.$store.state.feedback.currentSurveyAnswers;
        },
        currentStepComponent() {
            if (
                this.currentStep &&
                this.currentStep.type &&
                this.currentStep.type.name
            ) {
                switch (this.currentStep.type.name) {
                    case "Yes No":
                        return "StepYesNo";
                    case "Ordered Tags":
                        return "StepOrderedTags";
                    case "Scale":
                        return "StepScale";
                    case "Only Feedback":
                        return "StepOnlyFeedback";
                    case "Multi Choice":
                        return "StepMultiChoice";
                    default:
                        return "StepYesNo";
                }
            }
            else {
                return "StepYesNo";
            }
        },
        showAddFeedbackBtn() {
            return !this.showAddFeedback;
        },
        isAuthenticated() {
            return !!this.$store.state.auth.accessToken;
        },
        surveyPassingId() {
            return (
                (this.savedAnswers &&
                    this.savedAnswers[0] &&
                    this.savedAnswers[0].survey_passing_id) ||
                null
            );
        },
    },
    methods: {
        defineCurrentStep() {
            if (
                this.currentSurveyAnswers &&
                this.currentSurveyAnswers.answers &&
                this.currentSurveyAnswers.answers.length
            ) {
                if (this.currentSurveyAnswers.answers.length === this.maxStepsCount) {
                    this.surveyAlreadyCompleted = true;
                }

                let self = this;
                let arr = this._lodash.map(this.currentSurveyQuestions, function(item){
                    let answ = self._lodash.find(self.currentSurveyAnswers.answers,
                        question => {return question.question_id == item.id});
                    if (answ && answ.answer_data) {
                        item['answer_data'] = answ.answer_data;
                    }
                    return item;
                });
                let indexOfQuestionWithNoAnswer = this._lodash.findIndex(arr, item => !item.answer_data);
                if(indexOfQuestionWithNoAnswer === -1) {
                    this.stepProgress = this.maxStepsCount + 1;
                } else if(indexOfQuestionWithNoAnswer) {
                    this.stepProgress = indexOfQuestionWithNoAnswer + 1;
                } else {
                    this.stepProgress =
                        this.currentSurveyAnswers.answers.length + 1;
                }
            }
            this.currentStep = this.currentSurveyQuestions[
                this.stepProgress - 1
            ];
            this.savedAnswers =
                this.currentSurveyAnswers && this.currentSurveyAnswers.answers;
        },
        footerBtnAction(needSkip = false) {
            if (this.stepProgress <= this.maxStepsCount && this.canProgress) {
                if (this.showAddFeedback) {
                    this.saveTextFeedback();
                } /* else { */
                    this.continueStep(needSkip);
                /* } */
            } else if (this.canProgress) {
                this.closePage();
            }
        },
        saveStepAnswer(needSkip) {
            clearTimeout(this.timeoutId);
            if (
                this.$refs.currentComponent &&
                this.$refs.currentComponent.stepResult
            ) {

                let newStepResult = this.$refs.currentComponent.stepResult;

                this.processing = true;
                if (!needSkip) {
                    if (
                        this.$refs.currentComponent &&
                        this.$refs.currentComponent.canContinue
                    ) {
                        this.$store
                            .dispatch(
                                "saveFeedback",
                                this._lodash.assign(newStepResult, {
                                    feedback: this.feedbackText,
                                }),
                            )
                            .then((response) => {
                                this.savedAnswers = this._lodash.reject(
                                    this.savedAnswers,
                                    { question_id: response.data.question_id },
                                );
                                this.savedAnswers.push(response.data);
                                this.stepProgress = this.stepProgress + 1;
                                this.currentStep = this.currentSurveyQuestions[
                                    this.stepProgress - 1
                                ];
                                this.processing = false;
                            })
                            .catch((err) => {
                                if (
                                    err.message ===
                                    "Answer on this question already exists."
                                ) {
                                    this.stepProgress = this.stepProgress + 1;
                                    this.currentStep = this.currentSurveyQuestions[
                                        this.stepProgress - 1
                                    ];
                                }
                                this.processing = false;
                            });
                    } else {
                        this.processing = false;
                    }
                } else {
                    this.stepProgress = this.stepProgress + 1;
                    this.currentStep = this.currentSurveyQuestions[
                        this.stepProgress - 1
                    ];
                    this.processing = false;
                }
            }
        },
        continueStep(needSkip) {
            this.saveStepAnswer(needSkip);
        },
        openAddFeedbackStep(show) {
            if (this.currentStep.type.name == "Only Feedback")
                this.showAddFeedback = show
        },
        saveTextFeedback() {
            this.feedbackText =
                this.$refs.stepAddFeedback &&
                this.$refs.stepAddFeedback.feedbackText;

            this.showAddFeedback = false;
        },
        closePage() {
            this.$router.push({ name: "get-started" });
            /* this.$store.dispatch("logout").finally(() => {
                this.$router.push({ name: "sign-in" });
            }); */
        },
        goBack() {
            if (this.stepProgress !== 1) {
                if (this.showAddFeedback) {
                    this.showAddFeedback = false;
                } else {
                    this.stepProgress = this.stepProgress - 1;

                    this.currentStep = this.currentSurveyQuestions[
                        this.stepProgress - 1
                    ];
                }
            }
        }
    },
    watch: {
        stepProgress() {
            if (this.savedAnswers) {

                let currentAnswer = this.savedAnswers.find((answ) => {
                    return (
                        answ.question_id ==
                        (this.currentStep && this.currentStep.id)
                    );
                });
                this.feedbackText =
                    (currentAnswer && currentAnswer.feedback) || "";
            } else {
                this.feedbackText = "";
            }
            if (this.currentStep) {
                switch (this.currentStep.type.name) {
                    case "Only Feedback":
                        this.openAddFeedbackStep(true);
                        break;
                }
            }
        },
    },
};
</script>

<style scoped></style>
